import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { visitRequest } from '@services/VisitRequest/VisitRequest';
import {
  IMappedVisitRequestResponse,
  IverfiyOTPResponse,
} from '@interfaces/VisitRequestLookups.interface';

export const useVerifyOTP = () => {
  return useMutation<IMappedVisitRequestResponse, AxiosError, { requestId: string; otp: string }>(
    async (params) => {
      const { data } = await visitRequest.verifyOTP(params);
      return mapLookupData(data);
    }
  );
};

const mapLookupData = (data: IverfiyOTPResponse): IMappedVisitRequestResponse => {
  return {
    identity: data.identity,
    identityValue: data.identityValue,
    isVVIP: data.isVVIP,
    jiraTicketId: data.jiraTicketId,
    mobileNumber: data.mobileNumber,
    visitDateTime: data.visitDateTime,
    visitorEmail: data.visitorEmail,
    visitorName: data.visitorName,
    identityList: data.identityList
      ? data.identityList.map(({ key, value, valueAr }) => ({
          label: value,
          labelAr: valueAr,
          value: key,
          id: value,
        }))
      : [],
  };
};
